import React from 'react';
import { render } from 'react-dom';
import { Router, useRouterHistory } from 'react-router';
import { createHistory } from 'history';

import '../css/app.scss';

import humanRoutes from './human/humanRoutes';
import courseRoutes from './course/courseRoutes';
import horseRoutes from './horse/horseRoutes';

import rpLibs from './rpLibs';
import analyticsPage from './analyticsPage';
import { isBloodstockHorseProfile } from './utils/isBloodstockHorseProfile';

rpLibs.beforeRender();

const routes = [...humanRoutes, courseRoutes, horseRoutes];

const browserHistory = useRouterHistory(createHistory)({
    basename: '/profile/',
});

const onRouteUpdate = () => {
    const { pathname, search, hash } = browserHistory.getCurrentLocation();
    const newRoute = `${pathname}${search}${hash}`;
    const routeParts = newRoute.split('/').filter(routePart => routePart !== '');

    const isBloodstockProfile = isBloodstockHorseProfile();

    if ((routeParts.length >= 3) && isBloodstockProfile) {
        analyticsPage();
    }
};

render(
    <Router routes={routes} history={browserHistory} onUpdate={() => { onRouteUpdate(); }} />,
    document.querySelector('main')
);

rpLibs.afterRender();


export { browserHistory as default };



// WEBPACK FOOTER //
// ./src/js/index.jsx